import Link from 'next/link';

import { Image } from '@zoomit/primitives';
import { theme } from '@zoomit/zoomit-ds';

import { BaseMediaUrl } from '../../constants/apis';
import type { DisplaySource } from '../../types/modules';

type Props = {
  source: DisplaySource;
  onDisplayClick(): void;
  code: string;
  hasBorderRadius: boolean;
};

const ImageSource = (props: Props) => {
  const { source, onDisplayClick, code, hasBorderRadius } = props;
  if (source.sourceType !== 'Image') return null;

  return (
    <Link
      href={source.targetUrl}
      onClick={onDisplayClick}
      target="_blank"
      rel={source.isSponsored ? 'sponsored' : undefined}
      style={{ display: 'flex', objectFit: 'contain' }}
    >
      <Image
        fill
        unoptimized
        src={`${BaseMediaUrl}/${source.mediaId}`}
        alt={code}
        data-code={code}
        style={{
          objectFit: 'contain',
          objectPosition: 'center center',
          borderRadius: hasBorderRadius ? `var(${theme.radius.sm})` : 'unset',
        }}
      />
    </Link>
  );
};

export default ImageSource;
